import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, resolveDirective as _resolveDirective, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"20px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = { class: "col-lg-6 d-flex flex-column justify-content-end" }
const _hoisted_6 = {
  class: "navbar navbar-light navbar-expand-md mt-5",
  style: {"background-color":"rgba(0, 0, 0, 0.03)","border":"1px solid rgba(0, 0, 0, 0.125)","border-bottom":"0"},
  role: "navigation"
}
const _hoisted_7 = { class: "navbar-nav" }
const _hoisted_8 = { class: "dropdown mr-2" }
const _hoisted_9 = { class: "navbar-form" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  class: "btn-group mr-2",
  role: "group"
}
const _hoisted_12 = { class: "btn-group" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "dropdown-menu" }
const _hoisted_15 = {
  class: "btn-group",
  title: "Lock / Unlock"
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "dropdown-menu" }
const _hoisted_18 = {
  class: "btn-group mr-2",
  role: "group"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  class: "btn-group",
  title: "Lock / Unlock"
}
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "dropdown-menu" }
const _hoisted_23 = {
  class: "btn-group mr-2",
  role: "group"
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  class: "btn-group",
  title: "Lock / Unlock"
}
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "dropdown-menu" }
const _hoisted_28 = { class: "btn-group mr-2" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "dropdown-menu" }
const _hoisted_31 = { class: "navbar-nav ml-auto mr-2" }
const _hoisted_32 = { class: "dropdown" }
const _hoisted_33 = { class: "navbar-form" }
const _hoisted_34 = { class: "btn-group" }
const _hoisted_35 = {
  class: "btn btn-outline-secondary dropdown-toggle",
  "data-toggle": "dropdown"
}
const _hoisted_36 = { class: "dropdown-menu" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  class: "form-inline my-2 my-lg-0",
  role: "search"
}
const _hoisted_39 = { class: "table table-bordered table-hover" }
const _hoisted_40 = { style: {"width":"40px","min-width":"40px !important"} }
const _hoisted_41 = { class: "btn-group" }
const _hoisted_42 = ["onUpdate:modelValue"]
const _hoisted_43 = { class: "text-primary" }
const _hoisted_44 = { class: "d-flex align-items-center mt-1 plan-meta" }
const _hoisted_45 = { class: "plan-text" }
const _hoisted_46 = ["title", "onClick"]
const _hoisted_47 = ["title", "onClick"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "text-center align-middle" }
const _hoisted_50 = ["href"]
const _hoisted_51 = ["href"]
const _hoisted_52 = { class: "text-center align-middle" }
const _hoisted_53 = { class: "text-center align-middle" }
const _hoisted_54 = {
  key: 1,
  class: "btn-group"
}
const _hoisted_55 = {
  class: "text-primary dropdown-toggle",
  "data-toggle": "dropdown"
}
const _hoisted_56 = { class: "dropdown-menu" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = ["onClick"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = {
  class: "text-center align-middle",
  style: {"width":"40px"}
}
const _hoisted_61 = ["onClick"]
const _hoisted_62 = ["onClick", "disabled"]
const _hoisted_63 = { class: "text-center align-middle" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = {
  class: "text-center align-middle",
  style: {"width":"40px"}
}
const _hoisted_66 = ["onClick"]
const _hoisted_67 = ["onClick"]
const _hoisted_68 = { class: "text-center align-middle" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = ["onClick"]
const _hoisted_71 = {
  class: "text-center align-middle",
  style: {"width":"40px"}
}
const _hoisted_72 = ["onClick"]
const _hoisted_73 = ["disabled", "onClick"]
const _hoisted_74 = { class: "text-center align-middle" }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = { class: "text-center align-middle" }
const _hoisted_77 = ["onClick"]

import { computed, onMounted, shallowReactive, ref, watch, type Ref } from 'vue'
    import { useRoute } from 'vue-router'

    import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue'
    import { MonthPickerDialogViewModel } from '@common/Components/MonthPickerDialog'
    import MonthPickerDialog from '@common/Components/MonthPickerDialog.vue'
    import { MonthYear, MonthYearHelpers, ProjectAcceptance } from '@common/types'

    import { AddProjectsDialogViewModel } from '@Quest/PortfolioScenarios/Components/AddProjectsDialog'
    import AddProjectsDialog from '@Quest/PortfolioScenarios/Components/AddProjectsDialog.vue'

    import PortfolioScenarioNavigation from '@Quest/PortfolioScenarios/Components/PortfolioScenarioNavigation.vue'

    import { ProjectPlanPickerDialogViewModel } from '@Quest/PortfolioScenarios/Components/ProjectPlanPickerDialog'
    import ProjectPlanPickerDialog from '@Quest/PortfolioScenarios/Components/ProjectPlanPickerDialog.vue'

    import type { ProjectsPageReadModel, ScenarioProjectPlanPickerReadModel, ScenarioProjectReadModel } from '@Quest/PortfolioScenarios/readmodels'

    import { useProjectsPageQueryV1, useScenarioProjectPlanPickerQueryV1 } from '@Quest/PortfolioScenarios/queries-vue-composables'

    import
        {
            useAddProjectsToScenarioCommandV1,
            useRemoveProjectsFromScenarioCommandV1,
            useUpdateProjectScenarioAcceptanceCommandV1,

            useLockProjectScenarioAcceptanceCommandV1,
            useUnlockProjectScenarioAcceptanceCommandV1,

            useUpdateProjectScenarioCommitmentDateCommandV1,
            useLockProjectScenarioCommitmentDateCommandV1,
            useUnlockProjectScenarioCommitmentDateCommandV1,

            useUpdateProjectScenarioStartDateCommandV1,
            useLockProjectScenarioStartDateCommandV1,
            useUnlockProjectScenarioStartDateCommandV1,

            useUpdateProjectScenarioMinStartDateCommandV1,
            useUpdateProjectScenarioMaxStartDateCommandV1,

            useUpdateProjectScenarioPlanLockCommandV1
        } from '@Quest/PortfolioScenarios/commands-vue-composables'

    import { LockProjectScenarioAcceptanceCommandV1, RemoveProjectsFromScenarioCommandV1, UnlockProjectScenarioAcceptanceCommandV1, UpdateProjectScenarioAcceptanceCommandV1, UpdateProjectScenarioCommitmentDateCommandV1, UpdateProjectScenarioMaxStartDateCommandV1, UpdateProjectScenarioMinStartDateCommandV1, UpdateProjectScenarioPlanLockCommandV1, UpdateProjectScenarioStartDateCommandV1 } from '../commands-core'


    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectsPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params?.workspaceId ?? 0))
    const tchProjectId = computed(() => Number(route.params?.tchProjectId ?? 0))
    const scenarioId = computed(() => String(route.params?.scenarioId ?? ''))

    const {
        runProjectsPageQueryV1,
        modelProjectsPageQueryV1
    } = useProjectsPageQueryV1(workspaceId, tchProjectId, scenarioId)

    const rm = modelProjectsPageQueryV1 as Ref<ProjectsPageReadModel | null>

    const portfolioId = computed(() => rm.value?.PortfolioId ?? null)

    // Plan picker query
    const {
        runScenarioProjectPlanPickerQueryV1,
        modelScenarioProjectPlanPickerQueryV1
    } = useScenarioProjectPlanPickerQueryV1(workspaceId, tchProjectId, scenarioId)

    const planPickerRm = modelScenarioProjectPlanPickerQueryV1 as Ref<ScenarioProjectPlanPickerReadModel | null>

    // ======================
    // State (kept 1:1)
    // ======================

    const searchPhrase = ref<string | null>(null)
    const acceptanceFilter = ref<ProjectAcceptance | null>(null)
    const kanbanFilter = ref<string | null>(null)
    const batchOperationEntities = ref<any[]>([])

    const addProjectsDialog = shallowReactive(new AddProjectsDialogViewModel())
    const startDateMonthPicker = shallowReactive(new MonthPickerDialogViewModel())
    const minStartDateMonthPicker = shallowReactive(new MonthPickerDialogViewModel())
    const maxStartDateMonthPicker = shallowReactive(new MonthPickerDialogViewModel())
    const commitmentDateMonthPicker = shallowReactive(new MonthPickerDialogViewModel())
    const projectPlanPickerDialog = shallowReactive(new ProjectPlanPickerDialogViewModel())

    // ======================
    // Derived (former getters)
    // ======================

    const noneSelected = computed(() => !rm.value!.Projects.some(a => a.UiSelected))
    const allSelected = computed(() => !rm.value!.Projects.some(a => !a.UiSelected))
    const anySelected = computed(() => rm.value!.Projects.some(a => a.UiSelected))

    const selected = computed<ScenarioProjectReadModel[]>(
        () => rm.value!.Projects.filter(a => a.UiSelected) || []
    )

    const projectsView = computed<ScenarioProjectReadModel[]>(() =>
    {
        let view = new Array(...rm.value!.Projects)

        if (searchPhrase.value)
        {
            const phrase = searchPhrase.value.toLowerCase()
            view = view.filter(a => a.Name.toLowerCase().indexOf(phrase) > -1)
        }

        if (acceptanceFilter.value)
        {
            return view.filter(a => a.Acceptance === acceptanceFilter.value)
        }

        if (kanbanFilter.value)
        {
            return view.filter(a => a.KanbanStatus === kanbanFilter.value)
        }

        return view
    })

    const filterLabel = computed(() =>
    {
        if (kanbanFilter.value) return kanbanFilter.value
        if (acceptanceFilter.value) return acceptanceFilter.value
        return 'All'
    })

    // ======================
    // UI actions (kept names / behaviour)
    // ======================

    function selectAll()
    {
        projectsView.value.forEach(a => (a.UiSelected = true))
    }

    function unselectAll()
    {
        rm.value!.Projects.forEach(a => (a.UiSelected = false))
    }

    function setFilter(newAcceptanceFilter: ProjectAcceptance | null, newKanbanFilter: string | null)
    {
        kanbanFilter.value = newKanbanFilter
        acceptanceFilter.value = newAcceptanceFilter
    }

    function showAddProjectsDialog()
    {
        addProjectsDialog.show(rm.value!.Lists, rm.value!.Statuses)
    }

    function showPlanPicker(p: ScenarioProjectReadModel)
    {
        if (p.Plans.length)
        {
            projectPlanPickerDialog.show(p.Id, p.Name, p.ActivePlanId, p.LockedPlanId)
            projectPlanPickerDialog.setData(p.Plans)
        } else
        {
            runScenarioProjectPlanPickerQueryV1({ ProjectId: p.Id })
            projectPlanPickerDialog.show(p.Id, p.Name, p.ActivePlanId, p.LockedPlanId)
        }
    }

    function showStartDateMonthPicker(project: ScenarioProjectReadModel | null)
    {
        batchOperationEntities.value = project != null ? [project.Id] : selected.value.map(a => a.Id)

        const startDate = project?.StartDate ?? project?.DefaultStartDate ?? null
        startDateMonthPicker.show(MonthYearHelpers.buildFromMonthYearString(startDate), 'Edit start date')
    }

    function showMinStartDateMonthPicker(project: ScenarioProjectReadModel | null)
    {
        batchOperationEntities.value = project != null ? [project.Id] : selected.value.map(a => a.Id)
        minStartDateMonthPicker.show(
            MonthYearHelpers.buildFromMonthYearString(project?.MinStartDate ?? null),
            'Edit min start date'
        )
    }

    function showMaxStartDateMonthPicker(project: ScenarioProjectReadModel | null)
    {
        batchOperationEntities.value = project != null ? [project.Id] : selected.value.map(a => a.Id)
        maxStartDateMonthPicker.show(
            MonthYearHelpers.buildFromMonthYearString(project?.MaxStartDate ?? null),
            'Edit max start date'
        )
    }

    function showCommitmentDateMonthPicker(project: ScenarioProjectReadModel | null)
    {
        batchOperationEntities.value = project != null ? [project.Id] : selected.value.map(a => a.Id)
        commitmentDateMonthPicker.show(
            MonthYearHelpers.buildFromMonthYearString(project?.CommitmentDate ?? null),
            'Edit commitment date'
        )
    }

    // ======================
    // Commands (composables)
    // ======================

    const {
        invokeAddProjectsToScenarioCommandV1,
        onSucceedAddProjectsToScenarioCommandV1
    } = useAddProjectsToScenarioCommandV1(workspaceId, portfolioId, scenarioId)

    const {
        invokeRemoveProjectsFromScenarioCommandV1,
        onSucceedRemoveProjectsFromScenarioCommandV1,
        command: removeProjectsFromScenarioCommandV1
    } = useRemoveProjectsFromScenarioCommandV1(workspaceId, portfolioId, scenarioId)

    const {
        invokeUpdateProjectScenarioAcceptanceCommandV1,
        onSucceedUpdateProjectScenarioAcceptanceCommandV1,
        result: resultUpdateProjectScenarioAcceptanceCommandV1,
        command: updateProjectScenarioAcceptanceCommandV1
    } = useUpdateProjectScenarioAcceptanceCommandV1(workspaceId, portfolioId, scenarioId)

    const {
        invokeLockProjectScenarioAcceptanceCommandV1,
        onSucceedLockProjectScenarioAcceptanceCommandV1,
        result: resultLockProjectScenarioAcceptanceCommandV1,
        command: lockProjectScenarioAcceptanceCommandV1
    } = useLockProjectScenarioAcceptanceCommandV1(workspaceId, portfolioId, scenarioId)

    const {
        invokeUnlockProjectScenarioAcceptanceCommandV1,
        onSucceedUnlockProjectScenarioAcceptanceCommandV1,
        result: resultUnlockProjectScenarioAcceptanceCommandV1,
        command: unlockProjectScenarioAcceptanceCommandV1
    } = useUnlockProjectScenarioAcceptanceCommandV1(workspaceId, portfolioId, scenarioId)

    const {
        invokeUpdateProjectScenarioCommitmentDateCommandV1,
        onSucceedUpdateProjectScenarioCommitmentDateCommandV1,
        result: resultUpdateProjectScenarioCommitmentDateCommandV1,
        command: updateProjectScenarioCommitmentDateCommandV1
    } = useUpdateProjectScenarioCommitmentDateCommandV1(workspaceId, portfolioId, scenarioId)

    const {
        invokeLockProjectScenarioCommitmentDateCommandV1,
        onSucceedLockProjectScenarioCommitmentDateCommandV1,
        result: resultLockProjectScenarioCommitmentDateCommandV1,
        command: lockProjectScenarioCommitmentDateCommandV1
    } = useLockProjectScenarioCommitmentDateCommandV1(workspaceId, portfolioId, scenarioId)

    const {
        invokeUnlockProjectScenarioCommitmentDateCommandV1,
        onSucceedUnlockProjectScenarioCommitmentDateCommandV1,
        result: resultUnlockProjectScenarioCommitmentDateCommandV1,
        command: unlockProjectScenarioCommitmentDateCommandV1
    } = useUnlockProjectScenarioCommitmentDateCommandV1(workspaceId, portfolioId, scenarioId)

    const {
        invokeUpdateProjectScenarioStartDateCommandV1,
        onSucceedUpdateProjectScenarioStartDateCommandV1,
        result: resultUpdateProjectScenarioStartDateCommandV1,
        command: updateProjectScenarioStartDateCommandV1
    } = useUpdateProjectScenarioStartDateCommandV1(workspaceId, portfolioId, scenarioId)

    const {
        invokeLockProjectScenarioStartDateCommandV1,
        onSucceedLockProjectScenarioStartDateCommandV1,
        result: resultLockProjectScenarioStartDateCommandV1,
        command: lockProjectScenarioStartDateCommandV1
    } = useLockProjectScenarioStartDateCommandV1(workspaceId, portfolioId, scenarioId)

    const {
        invokeUnlockProjectScenarioStartDateCommandV1,
        onSucceedUnlockProjectScenarioStartDateCommandV1,
        result: resultUnlockProjectScenarioStartDateCommandV1,
        command: unlockProjectScenarioStartDateCommandV1
    } = useUnlockProjectScenarioStartDateCommandV1(workspaceId, portfolioId, scenarioId)

    const {
        invokeUpdateProjectScenarioMinStartDateCommandV1,
        onSucceedUpdateProjectScenarioMinStartDateCommandV1,
        result: resultUpdateProjectScenarioMinStartDateCommandV1,
        command: updateProjectScenarioMinStartDateCommandV1
    } = useUpdateProjectScenarioMinStartDateCommandV1(workspaceId, portfolioId, scenarioId)

    const {
        invokeUpdateProjectScenarioMaxStartDateCommandV1,
        onSucceedUpdateProjectScenarioMaxStartDateCommandV1,
        result: resultUpdateProjectScenarioMaxStartDateCommandV1,
        command: updateProjectScenarioMaxStartDateCommandV1
    } = useUpdateProjectScenarioMaxStartDateCommandV1(workspaceId, portfolioId, scenarioId)

    const {
        invokeUpdateProjectScenarioPlanLockCommandV1,
        onSucceedUpdateProjectScenarioPlanLockCommandV1,
        result: resultUpdateProjectScenarioPlanLockCommandV1,
        command: updateProjectScenarioPlanLockCommandV1
    } = useUpdateProjectScenarioPlanLockCommandV1(workspaceId, portfolioId, scenarioId)

    // ======================
    // Template handlers (kept names / signatures)
    // ======================

    function handleUpdateProjectScenarioPlanLockCommand(e: { projectId: string; lockedPlanId: string | null })
    {
        invokeUpdateProjectScenarioPlanLockCommandV1({
            ProjectId: e.projectId,
            LockedPlanId: e.lockedPlanId
        })
    }

    function handleLockProjectScenarioAcceptanceCommand(projectId: string | null)
    {
        const ids = projectId != null ? [projectId] : selected.value.map(a => a.Id)
        invokeLockProjectScenarioAcceptanceCommandV1({ ProjectIds: ids })
    }

    function handleUnlockProjectScenarioAcceptanceCommand(projectId: string | null)
    {
        const ids = projectId != null ? [projectId] : selected.value.map(a => a.Id)
        invokeUnlockProjectScenarioAcceptanceCommandV1({ ProjectIds: ids })
    }

    function handleLockProjectScenarioStartDateCommand(projectId: string | null)
    {
        const ids = projectId != null ? [projectId] : selected.value.map(a => a.Id)
        invokeLockProjectScenarioStartDateCommandV1({ ProjectIds: ids })
    }

    function handleUnlockProjectScenarioStartDateCommand(projectId: string | null)
    {
        const ids = projectId != null ? [projectId] : selected.value.map(a => a.Id)
        invokeUnlockProjectScenarioStartDateCommandV1({ ProjectIds: ids })
    }

    function handleLockProjectScenarioCommitmentDateCommand(projectId: string | null)
    {
        const ids = projectId != null ? [projectId] : selected.value.map(a => a.Id)
        invokeLockProjectScenarioCommitmentDateCommandV1({ ProjectIds: ids })
    }

    function handleUnlockProjectScenarioCommitmentDateCommand(projectId: string | null)
    {
        const ids = projectId != null ? [projectId] : selected.value.map(a => a.Id)
        invokeUnlockProjectScenarioCommitmentDateCommandV1({ ProjectIds: ids })
    }

    function handleUpdateProjectScenarioStartDateCommand(date: MonthYear | null)
    {
        invokeUpdateProjectScenarioStartDateCommandV1({
            ProjectIds: batchOperationEntities.value,
            StartDate: date
        })
    }

    function handleUpdateProjectScenarioMinStartDateCommand(date: MonthYear | null)
    {
        invokeUpdateProjectScenarioMinStartDateCommandV1({
            ProjectIds: batchOperationEntities.value,
            MinStartDate: date
        })
    }

    function handleUpdateProjectScenarioMaxStartDateCommand(date: MonthYear | null)
    {
        invokeUpdateProjectScenarioMaxStartDateCommandV1({
            ProjectIds: batchOperationEntities.value,
            MaxStartDate: date
        })
    }

    function handleUpdateProjectScenarioCommitmentDateCommand(date: MonthYear | null)
    {
        invokeUpdateProjectScenarioCommitmentDateCommandV1({
            ProjectIds: batchOperationEntities.value,
            CommitmentDate: date
        })
    }

    function handleAddProjectsToScenarioCommand(viewDefId: string | null, statusId: number | null)
    {
        invokeAddProjectsToScenarioCommandV1({
            ViewDefId: viewDefId,
            KanbanStatusId: statusId
        })
    }

    function handleRemoveProjectsFromScenarioCommand(ids: string[] | null)
    {
        if (confirm('Are you sure you want to remove the selected items from this scenario?'))
        {
            const resolvedIds = ids ?? selected.value.map(a => a.Id)
            invokeRemoveProjectsFromScenarioCommandV1({ ProjectIds: resolvedIds })
        }
    }

    function handleUpdateProjectScenarioAcceptanceCommand(acceptance: string, id: string | null)
    {
        const ids = id != null ? [id] : selected.value.map(a => a.Id)
        invokeUpdateProjectScenarioAcceptanceCommandV1({
            ProjectIds: ids,
            Acceptance: acceptance
        })
    }

    function onSelected(_result: any)
    {
        runProjectsPageQueryV1()
    }

    function onScenarioUpdated()
    {
        runProjectsPageQueryV1()
    }


    onMounted(() =>
    {
        document.title = 'Portfolio Plan - Projects'
        runProjectsPageQueryV1()
    })

    watch(planPickerRm, (current, previous) =>
    {
        if (current && current !== previous)
        {
            const p = rm.value!.Projects.find(a => a.Id === current.ProjectId)
            if (p)
            {
                p.Plans = current.Plans
                projectPlanPickerDialog.setData(current.Plans)
            }
        }
    })

    onSucceedAddProjectsToScenarioCommandV1(() =>
    {
        runProjectsPageQueryV1()
        addProjectsDialog.close()
    })

    onSucceedRemoveProjectsFromScenarioCommandV1(() =>
    {
        const cmd = removeProjectsFromScenarioCommandV1.value as RemoveProjectsFromScenarioCommandV1

        rm.value!.Projects = rm.value!.Projects.filter(p => !cmd.ProjectIds.includes(p.Id))
    })

    onSucceedUpdateProjectScenarioAcceptanceCommandV1(() =>
    {
        const cmd = updateProjectScenarioAcceptanceCommandV1.value as UpdateProjectScenarioAcceptanceCommandV1
        const acceptance = cmd.Acceptance as ProjectAcceptance
        const ids = (resultUpdateProjectScenarioAcceptanceCommandV1.value as string).split(';')

       rm.value.Projects.filter(p => ids.includes(p.Id)).forEach(p => p.Acceptance = acceptance)
    })

    onSucceedLockProjectScenarioAcceptanceCommandV1(() =>
    {
        const cmd = lockProjectScenarioAcceptanceCommandV1.value as LockProjectScenarioAcceptanceCommandV1
        const ids = (resultLockProjectScenarioAcceptanceCommandV1.value as string).split(';')

        rm.value.Projects.filter(p => ids.includes(p.Id)).forEach(p => (p.AcceptanceLocked = true))
    })

    onSucceedUnlockProjectScenarioAcceptanceCommandV1(() =>
    {
        const cmd = unlockProjectScenarioAcceptanceCommandV1.value as UnlockProjectScenarioAcceptanceCommandV1
        const ids = (resultUnlockProjectScenarioAcceptanceCommandV1.value as string).split(';')

        rm.value!.Projects.filter(p => ids.includes(p.Id)).forEach(p => (p.AcceptanceLocked = false))
    })

    onSucceedUpdateProjectScenarioCommitmentDateCommandV1(() =>
    {
        const cmd = updateProjectScenarioCommitmentDateCommandV1.value as UpdateProjectScenarioCommitmentDateCommandV1
        const commitmentDate = MonthYearHelpers.toMonthYearString(cmd.CommitmentDate ?? null)
        const ids = (resultUpdateProjectScenarioCommitmentDateCommandV1.value as string).split(';')

        rm.value!.Projects.filter(p => ids.includes(p.Id)).forEach(p => (p.CommitmentDate = commitmentDate))
    })

    onSucceedLockProjectScenarioCommitmentDateCommandV1(() =>
    {
        const ids = (resultLockProjectScenarioCommitmentDateCommandV1.value as string).split(';')

        rm.value.Projects.filter(p => ids.includes(p.Id)).forEach(p => (p.CommitmentDateLocked = true))
    })

    onSucceedUnlockProjectScenarioCommitmentDateCommandV1(() =>
    {
        const ids = (resultUnlockProjectScenarioCommitmentDateCommandV1.value as string).split(';')

        rm.value.Projects.filter(p => ids.includes(p.Id)).forEach(p => (p.CommitmentDateLocked = false))
    })

    onSucceedUpdateProjectScenarioStartDateCommandV1(() =>
    {
        const cmd = updateProjectScenarioStartDateCommandV1.value as UpdateProjectScenarioStartDateCommandV1
        const startDate = MonthYearHelpers.toMonthYearString(cmd.StartDate ?? null)
        const ids = (resultUpdateProjectScenarioStartDateCommandV1.value as string).split(';')

        rm.value.Projects.filter(p => ids.includes(p.Id)).forEach(p => (p.StartDate = startDate))
    })

    onSucceedLockProjectScenarioStartDateCommandV1(() =>
    {
        const ids = (resultLockProjectScenarioStartDateCommandV1.value as string).split(';')

        rm.value.Projects.filter(p => ids.includes(p.Id)).forEach(p => (p.StartDateLocked = true))
    })

    onSucceedUnlockProjectScenarioStartDateCommandV1(() =>
    {
        const ids = (resultUnlockProjectScenarioStartDateCommandV1.value as string).split(';')

        rm.value.Projects.filter(p => ids.includes(p.Id)).forEach(p => (p.StartDateLocked = false))
    })

    onSucceedUpdateProjectScenarioMinStartDateCommandV1(() =>
    {
        const cmd = updateProjectScenarioMinStartDateCommandV1.value as UpdateProjectScenarioMinStartDateCommandV1
        const minStartDate = MonthYearHelpers.toMonthYearString(cmd.MinStartDate ?? null)
        const ids = (resultUpdateProjectScenarioMinStartDateCommandV1.value as string).split(';')

        rm.value.Projects.filter(p => ids.includes(p.Id)).forEach(p => (p.MinStartDate = minStartDate))
    })

    onSucceedUpdateProjectScenarioPlanLockCommandV1(() =>
    {
        const cmd = updateProjectScenarioPlanLockCommandV1.value as UpdateProjectScenarioPlanLockCommandV1

        const project = rm.value.Projects.find(a => a.Id === cmd.ProjectId)

        if (project)
        {
            project.LockedPlanId = cmd.LockedPlanId
            project.PlanId = project.LockedPlanId ?? project.ActivePlanId

            const plan = project.Plans?.find(p => p.Id === project.PlanId)
            project.PlanName = plan?.Name ?? null
        }

        projectPlanPickerDialog.close()
    })

    onSucceedUpdateProjectScenarioMaxStartDateCommandV1(() =>
    {
        const cmd = updateProjectScenarioMaxStartDateCommandV1.value as UpdateProjectScenarioMaxStartDateCommandV1
        const maxStartDate = MonthYearHelpers.toMonthYearString(cmd.MaxStartDate ?? null)
        const ids = (resultUpdateProjectScenarioMaxStartDateCommandV1.value as string).split(';')

        rm.value.Projects.filter(p => ids.includes(p.Id)).forEach(p => (p.MaxStartDate = maxStartDate))
    })

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(MonthPickerDialog, {
      viewModel: _unref(startDateMonthPicker),
      onUpdateDate: handleUpdateProjectScenarioStartDateCommand
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(MonthPickerDialog, {
      viewModel: _unref(minStartDateMonthPicker),
      onUpdateDate: handleUpdateProjectScenarioMinStartDateCommand
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(MonthPickerDialog, {
      viewModel: _unref(maxStartDateMonthPicker),
      onUpdateDate: handleUpdateProjectScenarioMaxStartDateCommand
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(MonthPickerDialog, {
      viewModel: _unref(commitmentDateMonthPicker),
      onUpdateDate: handleUpdateProjectScenarioCommitmentDateCommand
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(AddProjectsDialog, {
      viewModel: _unref(addProjectsDialog),
      onSelectionConfirmed: handleAddProjectsToScenarioCommand
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(ProjectPlanPickerDialog, {
      viewModel: _unref(projectPlanPickerDialog),
      onConfirmed: handleUpdateProjectScenarioPlanLockCommand
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(PortfolioNavigation, {
      workspaceId: workspaceId.value,
      projectId: tchProjectId.value
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("small", _hoisted_4, _toDisplayString(_unref(rm).PortfolioName) + " / " + _toDisplayString(_unref(rm).ScenarioName), 1 /* TEXT */),
              _cache[19] || (_cache[19] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Plan: Projects", -1 /* CACHED */))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(PortfolioScenarioNavigation, {
                portfolioId: _unref(rm).PortfolioId,
                corporateScenarioUrl: _unref(rm).CorporateScenarioUrl,
                onSelected: onSelected,
                onScenarioUpdated: onScenarioUpdated
              }, null, 8 /* PROPS */, ["portfolioId", "corporateScenarioUrl"])
            ])
          ]),
          _cache[49] || (_cache[49] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
          _createElementVNode("nav", _hoisted_6, [
            _createElementVNode("ul", _hoisted_7, [
              _createElementVNode("li", { class: "dropdown mr-2" }, [
                _createElementVNode("div", { class: "navbar-form" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-secondary",
                    onClick: showAddProjectsDialog
                  }, [...(_cache[20] || (_cache[20] = [
                    _createElementVNode("i", { class: "fa-solid fa-plus" }, null, -1 /* CACHED */),
                    _createTextVNode(" Add ", -1 /* CACHED */)
                  ]))])
                ])
              ]),
              _createElementVNode("li", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-secondary",
                    disabled: selected.value.length === 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (handleRemoveProjectsFromScenarioCommand(null)))
                  }, [...(_cache[21] || (_cache[21] = [
                    _createElementVNode("i", { class: "fa-regular fa-trash-can" }, null, -1 /* CACHED */)
                  ]))], 8 /* PROPS */, _hoisted_10)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  class: "btn btn-outline-secondary",
                  "data-toggle": "dropdown",
                  disabled: selected.value.length === 0
                }, " Selection ", 8 /* PROPS */, _hoisted_13),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (handleUpdateProjectScenarioAcceptanceCommand('Accepted', null)))
                  }, "Accepted"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (handleUpdateProjectScenarioAcceptanceCommand('Rejected', null)))
                  }, "Rejected"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (handleUpdateProjectScenarioAcceptanceCommand('TBD', null)))
                  }, "TBD")
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  class: "btn btn-outline-secondary custom-rounded-right",
                  "data-toggle": "dropdown",
                  disabled: selected.value.length === 0
                }, [...(_cache[22] || (_cache[22] = [
                  _createElementVNode("i", { class: "fa-solid fa-lock" }, null, -1 /* CACHED */)
                ]))], 8 /* PROPS */, _hoisted_16),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (handleLockProjectScenarioAcceptanceCommand(null)))
                  }, "Lock"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (handleUnlockProjectScenarioAcceptanceCommand(null)))
                  }, "Unlock")
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                class: "btn btn-outline-secondary",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (showCommitmentDateMonthPicker(null))),
                disabled: selected.value.length === 0
              }, " Commitment ", 8 /* PROPS */, _hoisted_19),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  class: "btn btn-outline-secondary custom-rounded-right",
                  "data-toggle": "dropdown",
                  disabled: selected.value.length === 0
                }, [...(_cache[23] || (_cache[23] = [
                  _createElementVNode("i", { class: "fa-solid fa-lock" }, null, -1 /* CACHED */)
                ]))], 8 /* PROPS */, _hoisted_21),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (handleLockProjectScenarioCommitmentDateCommand(null)))
                  }, "Lock"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (handleUnlockProjectScenarioCommitmentDateCommand(null)))
                  }, "Unlock")
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", {
                class: "btn btn-outline-secondary",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (showStartDateMonthPicker(null))),
                disabled: selected.value.length === 0
              }, " Start date ", 8 /* PROPS */, _hoisted_24),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("button", {
                  class: "btn btn-outline-secondary custom-rounded-right",
                  "data-toggle": "dropdown",
                  disabled: selected.value.length === 0
                }, [...(_cache[24] || (_cache[24] = [
                  _createElementVNode("i", { class: "fa-solid fa-lock" }, null, -1 /* CACHED */)
                ]))], 8 /* PROPS */, _hoisted_26),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (handleLockProjectScenarioStartDateCommand(null)))
                  }, "Lock"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (handleUnlockProjectScenarioStartDateCommand(null)))
                  }, "Unlock")
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("button", {
                class: "btn btn-outline-secondary custom-rounded-right",
                "data-toggle": "dropdown",
                disabled: selected.value.length === 0
              }, " Start range ", 8 /* PROPS */, _hoisted_29),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (showMinStartDateMonthPicker(null)))
                }, "Min start date"),
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (showMaxStartDateMonthPicker(null)))
                }, "Max start date")
              ])
            ]),
            _createElementVNode("ul", _hoisted_31, [
              _createElementVNode("li", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("button", _hoisted_35, "Filter: " + _toDisplayString(filterLabel.value), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (setFilter(null, null)))
                      }, "All"),
                      _cache[25] || (_cache[25] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                      _cache[26] || (_cache[26] = _createElementVNode("h6", { class: "dropdown-header" }, "Filter by selection status:", -1 /* CACHED */)),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (setFilter('TBD', null)))
                      }, "TBD"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (setFilter('Accepted', null)))
                      }, "Accepted"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (setFilter('Rejected', null)))
                      }, "Rejected"),
                      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                      _cache[28] || (_cache[28] = _createElementVNode("h6", { class: "dropdown-header" }, "Filter by Kanban status:", -1 /* CACHED */)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).Statuses, (s) => {
                        return (_openBlock(), _createElementBlock("a", {
                          class: "dropdown-item",
                          key: s.Id,
                          onClick: ($event: any) => (setFilter(null, s.Name))
                        }, _toDisplayString(s.Name), 9 /* TEXT, PROPS */, _hoisted_37))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("form", _hoisted_38, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control mr-sm-2",
                type: "search",
                placeholder: "Search",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((searchPhrase).value = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, searchPhrase.value]
              ])
            ])
          ]),
          _createElementVNode("table", _hoisted_39, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    (noneSelected.value)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "pointer",
                          onClick: selectAll
                        }, [...(_cache[29] || (_cache[29] = [
                          _createElementVNode("i", { class: "fa-regular fa-square" }, null, -1 /* CACHED */)
                        ]))]))
                      : _createCommentVNode("v-if", true),
                    (anySelected.value && !allSelected.value)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          class: "pointer",
                          onClick: unselectAll
                        }, [...(_cache[30] || (_cache[30] = [
                          _createElementVNode("i", { class: "fa fa-minus-square" }, null, -1 /* CACHED */)
                        ]))]))
                      : _createCommentVNode("v-if", true),
                    (anySelected.value && allSelected.value)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 2,
                          class: "pointer",
                          onClick: unselectAll
                        }, [...(_cache[31] || (_cache[31] = [
                          _createElementVNode("i", { class: "fa-solid fa-square-check" }, null, -1 /* CACHED */)
                        ]))]))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                _cache[32] || (_cache[32] = _createElementVNode("th", { class: "text-left" }, "Project", -1 /* CACHED */)),
                _cache[33] || (_cache[33] = _createElementVNode("th", null, "P&L", -1 /* CACHED */)),
                _cache[34] || (_cache[34] = _createElementVNode("th", null, "Status", -1 /* CACHED */)),
                _cache[35] || (_cache[35] = _createElementVNode("th", { colspan: "2" }, "Selection", -1 /* CACHED */)),
                _cache[36] || (_cache[36] = _createElementVNode("th", { colspan: "2" }, "Commitment", -1 /* CACHED */)),
                _cache[37] || (_cache[37] = _createElementVNode("th", { colspan: "2" }, "Start date", -1 /* CACHED */)),
                _cache[38] || (_cache[38] = _createElementVNode("th", null, "Min start date", -1 /* CACHED */)),
                _cache[39] || (_cache[39] = _createElementVNode("th", null, "Max start date", -1 /* CACHED */))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectsView.value, (a) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: a.Id
                }, [
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": ($event: any) => ((a.UiSelected) = $event)
                    }, null, 8 /* PROPS */, _hoisted_42), [
                      [_vModelCheckbox, a.UiSelected]
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createCommentVNode(" Line 1: Project (primary link) "),
                    _createElementVNode("div", null, [
                      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_43, [
                        _createTextVNode(_toDisplayString(a.Name), 1 /* TEXT */)
                      ])), [
                        [_directive_sanitizedHref, `/#/portfolio/alternative/dashboard/${workspaceId.value}/${tchProjectId.value}/${a.Id}`]
                      ])
                    ]),
                    _createCommentVNode(" Line 2: Plan (click opens picker) "),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createCommentVNode(" EFFECTIVE PLAN AVAILABLE "),
                        (a.PlanId)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createCommentVNode(" Locked to a plan "),
                              (a.LockedPlanId)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: _normalizeClass(["small plan-toggle d-inline-flex align-items-center", 'text-locked-plan']),
                                    role: "button",
                                    title: a.PlanName ? `${a.PlanName} (locked)` : 'Locked plan',
                                    onClick: _withModifiers(($event: any) => (showPlanPicker(a)), ["prevent"])
                                  }, [
                                    _createTextVNode(_toDisplayString(a.PlanName || 'Unnamed plan') + " ", 1 /* TEXT */),
                                    _cache[40] || (_cache[40] = _createElementVNode("i", {
                                      class: "fa-solid fa-caret-down ml-1 plan-caret",
                                      "aria-hidden": "true"
                                    }, null, -1 /* CACHED */))
                                  ], 8 /* PROPS */, _hoisted_46))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createCommentVNode(" Following Active (no lock) "),
                                    _createElementVNode("a", {
                                      class: _normalizeClass(["small plan-toggle d-inline-flex align-items-center", a.ActivePlanId ? 'text-muted' : 'text-danger']),
                                      role: "button",
                                      title: a.ActivePlanId ? `${a.PlanName || 'Unnamed plan'} (follows Active)` : 'No Active plan set — click to choose',
                                      onClick: _withModifiers(($event: any) => (showPlanPicker(a)), ["prevent"])
                                    }, [
                                      _createTextVNode(_toDisplayString(a.PlanName || 'Unnamed plan') + " ", 1 /* TEXT */),
                                      _cache[41] || (_cache[41] = _createElementVNode("i", {
                                        class: "fa-solid fa-caret-down ml-1 plan-caret",
                                        "aria-hidden": "true"
                                      }, null, -1 /* CACHED */))
                                    ], 10 /* CLASS, PROPS */, _hoisted_47)
                                  ], 64 /* STABLE_FRAGMENT */))
                            ], 64 /* STABLE_FRAGMENT */))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createCommentVNode(" NO EFFECTIVE PLAN "),
                              _createElementVNode("a", {
                                class: "small text-danger plan-toggle d-inline-flex align-items-center",
                                role: "button",
                                title: "No plan available — click to choose",
                                onClick: _withModifiers(($event: any) => (showPlanPicker(a)), ["prevent"])
                              }, [...(_cache[42] || (_cache[42] = [
                                _createTextVNode(" No plan ", -1 /* CACHED */),
                                _createElementVNode("i", {
                                  class: "fa-solid fa-caret-down ml-1 plan-caret",
                                  "aria-hidden": "true"
                                }, null, -1 /* CACHED */)
                              ]))], 8 /* PROPS */, _hoisted_48)
                            ], 64 /* STABLE_FRAGMENT */))
                      ])
                    ])
                  ]),
                  _createCommentVNode(" P&L "),
                  _createElementVNode("td", _hoisted_49, [
                    (a.PlanId)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "text-primary",
                          href: `/#/q/project/pnl/${workspaceId.value}/${tchProjectId.value}/${a.Id}/${a.PlanId}`
                        }, " View ", 8 /* PROPS */, _hoisted_50))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          class: "text-danger",
                          href: `/#/q/project/summary/${workspaceId.value}/${tchProjectId.value}/${a.Id}`
                        }, " NA ", 8 /* PROPS */, _hoisted_51))
                  ]),
                  _createCommentVNode(" Status "),
                  _createElementVNode("td", _hoisted_52, _toDisplayString(a.KanbanStatus), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_53, [
                    (a.AcceptanceLocked === true)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(a.Acceptance), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    (a.AcceptanceLocked === false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          _createElementVNode("a", _hoisted_55, _toDisplayString(a.Acceptance), 1 /* TEXT */),
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              onClick: ($event: any) => (handleUpdateProjectScenarioAcceptanceCommand('Accepted', a.Id))
                            }, "Accepted", 8 /* PROPS */, _hoisted_57),
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              onClick: ($event: any) => (handleUpdateProjectScenarioAcceptanceCommand('Rejected', a.Id))
                            }, "Rejected", 8 /* PROPS */, _hoisted_58),
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              onClick: ($event: any) => (handleUpdateProjectScenarioAcceptanceCommand('TBD', a.Id))
                            }, "TBD", 8 /* PROPS */, _hoisted_59)
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("td", _hoisted_60, [
                    (a.AcceptanceLocked === true)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          title: "Unlock acceptance",
                          class: "btn btn-outline-secondary btn-sm",
                          onClick: ($event: any) => (handleUnlockProjectScenarioAcceptanceCommand(a.Id))
                        }, [...(_cache[43] || (_cache[43] = [
                          _createElementVNode("i", { class: "fa-solid fa-lock" }, null, -1 /* CACHED */)
                        ]))], 8 /* PROPS */, _hoisted_61))
                      : _createCommentVNode("v-if", true),
                    (a.AcceptanceLocked === false)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          title: "Lock acceptance",
                          class: "btn btn-outline-secondary btn-sm",
                          onClick: ($event: any) => (handleLockProjectScenarioAcceptanceCommand(a.Id)),
                          disabled: a.Acceptance === 'TBD'
                        }, [...(_cache[44] || (_cache[44] = [
                          _createElementVNode("i", { class: "fa-solid fa-lock-open" }, null, -1 /* CACHED */)
                        ]))], 8 /* PROPS */, _hoisted_62))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("td", _hoisted_63, [
                    (a.CommitmentDateLocked === true)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(a.CommitmentDate ?? 'Not set'), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    (a.CommitmentDateLocked === false)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          class: "text-primary",
                          onClick: ($event: any) => (showCommitmentDateMonthPicker(a))
                        }, _toDisplayString(a.CommitmentDate ?? 'Not set'), 9 /* TEXT, PROPS */, _hoisted_64))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("td", _hoisted_65, [
                    (a.CommitmentDateLocked === true)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          title: "Unlock commitment date",
                          class: "btn btn-outline-secondary btn-sm",
                          onClick: ($event: any) => (handleUnlockProjectScenarioCommitmentDateCommand(a.Id))
                        }, [...(_cache[45] || (_cache[45] = [
                          _createElementVNode("i", { class: "fa-solid fa-lock" }, null, -1 /* CACHED */)
                        ]))], 8 /* PROPS */, _hoisted_66))
                      : _createCommentVNode("v-if", true),
                    (a.CommitmentDateLocked === false)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          title: "Lock commitment date",
                          class: "btn btn-outline-secondary btn-sm",
                          onClick: ($event: any) => (handleLockProjectScenarioCommitmentDateCommand(a.Id))
                        }, [...(_cache[46] || (_cache[46] = [
                          _createElementVNode("i", { class: "fa-solid fa-lock-open" }, null, -1 /* CACHED */)
                        ]))], 8 /* PROPS */, _hoisted_67))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("td", _hoisted_68, [
                    (a.StartDateLocked === true)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(a.StartDate), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    (a.StartDateLocked === false)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (a.StartDate)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "text-primary",
                                onClick: ($event: any) => (showStartDateMonthPicker(a))
                              }, _toDisplayString(a.StartDate), 9 /* TEXT, PROPS */, _hoisted_69))
                            : _createCommentVNode("v-if", true),
                          (!a.StartDate)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "text-muted pointer",
                                onClick: ($event: any) => (showStartDateMonthPicker(a)),
                                title: "Not set - default value"
                              }, " Not set ", 8 /* PROPS */, _hoisted_70))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("td", _hoisted_71, [
                    (a.StartDateLocked === true)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          title: "Unlock start date",
                          class: "btn btn-outline-secondary btn-sm",
                          onClick: ($event: any) => (handleUnlockProjectScenarioStartDateCommand(a.Id))
                        }, [...(_cache[47] || (_cache[47] = [
                          _createElementVNode("i", { class: "fa-solid fa-lock" }, null, -1 /* CACHED */)
                        ]))], 8 /* PROPS */, _hoisted_72))
                      : _createCommentVNode("v-if", true),
                    (a.StartDateLocked === false)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          title: "Lock start date",
                          disabled: !a.StartDate,
                          class: "btn btn-outline-secondary btn-sm",
                          onClick: ($event: any) => (handleLockProjectScenarioStartDateCommand(a.Id))
                        }, [...(_cache[48] || (_cache[48] = [
                          _createElementVNode("i", { class: "fa-solid fa-lock-open" }, null, -1 /* CACHED */)
                        ]))], 8 /* PROPS */, _hoisted_73))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("td", _hoisted_74, [
                    _createElementVNode("a", {
                      class: "text-primary",
                      onClick: ($event: any) => (showMinStartDateMonthPicker(a))
                    }, _toDisplayString(a.MinStartDate ?? 'Not set'), 9 /* TEXT, PROPS */, _hoisted_75)
                  ]),
                  _createElementVNode("td", _hoisted_76, [
                    _createElementVNode("a", {
                      class: "text-primary",
                      onClick: ($event: any) => (showMaxStartDateMonthPicker(a))
                    }, _toDisplayString(a.MaxStartDate ?? 'Not set'), 9 /* TEXT, PROPS */, _hoisted_77)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _cache[50] || (_cache[50] = _createElementVNode("br", null, null, -1 /* CACHED */)),
    _cache[51] || (_cache[51] = _createElementVNode("br", null, null, -1 /* CACHED */)),
    _cache[52] || (_cache[52] = _createElementVNode("br", null, null, -1 /* CACHED */)),
    _cache[53] || (_cache[53] = _createElementVNode("br", null, null, -1 /* CACHED */))
  ]))
}
}

})